import type { AfterResponseHook } from "ky";

import { hideLoader } from "@/redux/actions/loader";
import store from "@/redux/store";

const dispatch = store.dispatch;

// Runs for ALL responses including 4xx/5xx (afterResponse fires before beforeError for HTTPErrors)
export const loaderEndHook: AfterResponseHook = () => {
  dispatch(hideLoader());
};
